/*
  Lullmap marker layer: hand-drawn underlines, boxes and circles in the planner's whiteboard style.
  Requires rough.js (assets/rough.js) loaded first. No animation; redraws on resize.

  Usage in HTML:
    <h1 data-marker="underline">Sleep, mapped</h1>              rose underline under the last line
    <div data-marker="box" data-color="sage">...</div>         hand-drawn box (rose | sage | brick | ink)
    <span data-marker="circle">$19</span>                      loose circle around inline text
*/
(function () {
  if (!window.rough) return;
  var COLORS = { rose: '#C2667A', sage: '#6E9A7E', brick: '#B8433A', ink: '#2B2B33' };
  var NS = 'http://www.w3.org/2000/svg';

  function seedFor(el) {
    var s = el.getAttribute('data-seed');
    if (s) return Number(s);
    var t = (el.textContent || '').length;
    return (t * 7) % 97 + 1; // stable per element, so shapes don't jitter between redraws
  }

  function overlay(el) {
    var svg = el.querySelector(':scope > svg.lm-marker');
    if (!svg) {
      if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
      svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('class', 'lm-marker');
      svg.setAttribute('aria-hidden', 'true');
      svg.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:100%;overflow:visible;pointer-events:none';
      el.appendChild(svg);
    }
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    return svg;
  }

  function draw(el) {
    var kind = el.getAttribute('data-marker');
    var color = COLORS[el.getAttribute('data-color')] || COLORS.rose;
    var svg = overlay(el);
    var rc = rough.svg(svg);
    var w = el.offsetWidth, h = el.offsetHeight;
    var opt = { stroke: color, roughness: 1.3, bowing: 1.2, seed: seedFor(el) };

    if (kind === 'underline') {
      var range = document.createRange();
      range.selectNodeContents(el);
      var rects = Array.prototype.filter.call(range.getClientRects(), function (r) { return r.width > 0; });
      if (!rects.length) return;
      var box = el.getBoundingClientRect();
      var bottom = Math.max.apply(null, rects.map(function (r) { return r.bottom; }));
      var line = rects.filter(function (r) { return Math.abs(r.bottom - bottom) < 6; });
      var x1 = Math.min.apply(null, line.map(function (r) { return r.left; })) - box.left;
      var x2 = Math.max.apply(null, line.map(function (r) { return r.right; })) - box.left;
      var y = bottom - box.top + 3;
      opt.strokeWidth = 3;
      svg.appendChild(rc.line(x1, y, x2, y + 2, opt));
    } else if (kind === 'box') {
      opt.strokeWidth = 1.8; opt.roughness = 1.1;
      svg.appendChild(rc.rectangle(1, 1, w - 2, h - 2, opt));
    } else if (kind === 'circle') {
      opt.strokeWidth = 2;
      svg.appendChild(rc.ellipse(w / 2, h / 2, w + 18, h + 14, opt));
    }
  }

  function drawAll() {
    document.querySelectorAll('[data-marker]').forEach(draw);
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(drawAll, 120); }

  if (document.fonts && document.fonts.ready) document.fonts.ready.then(drawAll); else drawAll();
  window.addEventListener('resize', schedule);
  window.lullmapMarker = { redraw: drawAll };
})();
